import { BlockConfig, OperationTypes, ContentTypes } from "../block-base";
import { BlockTypes } from "../block-types";

export const s3BucketConfig: BlockConfig = {
  displayName: "S3 Bucket",
  imagePath: "",
  isInitiator: true,
  isTerminator: false,
  isInterceptor: false,
  allowedInputTypes: new Set([
    BlockTypes.APP_SERVER,
    BlockTypes.AUTO_SCALING_GROUP,
    BlockTypes.LAMBDA,
    BlockTypes.CDN,
    BlockTypes.NETWORK_LOAD_BALANCER,
    BlockTypes.PASSTHROUGH,
  ]),
  allowedOutputTypes: new Set(),
  inputCapacity: {
    total: 10000,
    byOperationType: {
      [`${OperationTypes.READ}`]: {
        total: 8000,
        byContentType: {
          [`${ContentTypes.STATIC}`]: 3000,
          [`${ContentTypes.STATIC_MEDIA}`]: 5000,
        },
      },
      [`${OperationTypes.WRITE}`]: {
        total: 2000,
        byContentType: {
          //[`${ContentTypes.DYNAMIC}`]: 1500,
          [`${ContentTypes.STATIC_MEDIA}`]: 2000,
        },
      },
    },
  },
  processingCapacity: {
    total: 10000,
    byOperationType: {
      [`${OperationTypes.READ}`]: {
        total: 8000,
        byContentType: {
          [`${ContentTypes.STATIC}`]: 3000,
          [`${ContentTypes.STATIC_MEDIA}`]: 5000,
        },
      },
      [`${OperationTypes.WRITE}`]: {
        total: 2000,
        byContentType: {
          //[`${ContentTypes.DYNAMIC}`]: 1500,
          [`${ContentTypes.STATIC_MEDIA}`]: 2000,
        },
      },
    },
  },
  purchasePrice: 100,
  sellPrice: 50,
  costPerCycle: 0.3,
  outputConnectorLimits: {},
};
